import { unsafeFork, unsafeRunSyncExit, unsafeRunSync, unsafeRunCallback, unsafeRunPromise, unsafeRunPromiseExit, defaultRuntime as defaultRuntime$1, defaultRuntimeFlags as defaultRuntimeFlags$1, make as make$1, FiberFailureCauseId as FiberFailureCauseId$1, isAsyncFiberException as isAsyncFiberException$1, isFiberFailure as isFiberFailure$1, fiberFailure } from '../../internal/runtime.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Executes the effect using the provided Scheduler or using the global
 * Scheduler if not provided
 *
 * @since 2.0.0
 * @category execution
 */
const runFork = unsafeFork;

/**
 * Executes the effect synchronously returning the exit.
 *
 * This method is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
const runSyncExit = unsafeRunSyncExit;

/**
 * Executes the effect synchronously throwing in case of errors or async boundaries.
 *
 * This method is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
const runSync = unsafeRunSync;

/**
 * Executes the effect asynchronously, eventually passing the exit value to
 * the specified callback.
 *
 * This method is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
const runCallback = unsafeRunCallback;

/**
 * Runs the `Effect`, returning a JavaScript `Promise` that will be resolved
 * with the value of the effect once the effect has been executed, or will be
 * rejected with the first error or exception throw by the effect.
 *
 * This method is effectful and should only be used at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
const runPromise = unsafeRunPromise;

/**
 * Runs the `Effect`, returning a JavaScript `Promise` that will be resolved
 * with the `Exit` state of the effect once the effect has been executed.
 *
 * This method is effectful and should only be used at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category execution
 */
const runPromiseExit = unsafeRunPromiseExit;

/**
 * @since 2.0.0
 * @category constructors
 */
const defaultRuntime = defaultRuntime$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const defaultRuntimeFlags = defaultRuntimeFlags$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category symbols
 */
const FiberFailureId = /*#__PURE__*/Symbol.for("effect/Runtime/FiberFailure");
/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const FiberFailureCauseId = FiberFailureCauseId$1;

/**
 * @since 2.0.0
 * @category exports
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category guards
 */
const isAsyncFiberException = isAsyncFiberException$1;

/**
 * @since 2.0.0
 * @category guards
 */
const isFiberFailure = isFiberFailure$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const makeFiberFailure = fiberFailure;

export { FiberFailureCauseId, FiberFailureId, defaultRuntime, defaultRuntimeFlags, isAsyncFiberException, isFiberFailure, make, makeFiberFailure, runCallback, runFork, runPromise, runPromiseExit, runSync, runSyncExit };
